import { Component, Input } from '@angular/core';
import { PageChangedEvent } from '../../../utils/events/page-changed-event';
import { CommunicationService } from '../../../services/communication.service';

@Component({
    selector: 'app-page-turner',
    templateUrl: './page-turner.component.html',
    styleUrls: ['./page-turner.component.scss'],
    standalone: true
})
export class PageTurnerComponent {

    @Input() previous: boolean;
    @Input() next: boolean;

    constructor(private communicationService: CommunicationService) {
    }

    /**
     * Turn the page in the specified direction.
     */
    turnPage($event): void {
        let pageChangedEvent: PageChangedEvent;
        if (this.next) {
            pageChangedEvent = PageChangedEvent.createTurnPageForwardEvent();
        } else if (this.previous) {
            pageChangedEvent = PageChangedEvent.createTurnPageBackwardsEvent();
        }

        this.communicationService.announcePageTurn(pageChangedEvent);
    }
}
